// Copyright (c) Docugami, Inc. All rights reserved.

import { TokenRange } from "networking/api";
import { useCallback } from "react";
import { DgmlInstancesSingleton } from "./documentDgml";
import { SelectionModifier, setEditOperation, setSelection } from "store/sdvSlice";
import { AppDispatch, AppState, store } from "store";
import { useAppDispatch } from "./redux";

export const selectChunk = (spanId?: string, defaultLabel?: string, selectionModifier?: SelectionModifier) =>
    store.dispatch(selectChunkThunk(spanId, defaultLabel, selectionModifier));

export const setEditTokenRange = (tokenRange?: TokenRange) => store.dispatch(setEditOperation(tokenRange));

export const getSelectedChunk = () => store.dispatch(getSelectedChunkThunk());
export const getSelectedChunkThunk = () => (dispatch: AppDispatch, getState: () => AppState) => {
    const spanId = getState().sdv.document?.selection?.id;
    const folderId = getState().sdv.document?.folderId;
    if (!!spanId && !!folderId) {
        return DgmlInstancesSingleton.getInstanceById(folderId, spanId);
    }
}

export const selectChunkThunk = (spanId?: string, defaultLabel?: string, selectionModifier?: SelectionModifier) =>
    (dispatch: AppDispatch, getState: () => AppState) => {
        if (!spanId) {
            dispatch(setSelection(undefined));
        }
        else {
            dispatch(setSelection({
                id: spanId,
                defaultLabel: defaultLabel,
                selectionModifier: selectionModifier
            }));
        }
    }

export interface IChunkSelection {
    selectChunk(chunkInstanceId: string, suggestedType?: string, selectionModifier?: SelectionModifier): void;
    clearSelection(): void;
}

export function useChunkSelection(): IChunkSelection {
    const dispatch = useAppDispatch();
    const select = useCallback((chunkInstanceId: string, suggestedType?: string, selectionModifier?: SelectionModifier) => {
        dispatch(selectChunkThunk(chunkInstanceId, suggestedType, selectionModifier));
    }, [dispatch]);

    const clear = useCallback(() => dispatch(selectChunkThunk()), [dispatch]);

    return {
        selectChunk: select,
        clearSelection: clear
    };
}
